import {ModuleComponent} from "../../js/module-component";
import Swiper from 'swiper/bundle';
// import Swiper and modules styles
export class ModMultiSlide extends ModuleComponent{
    ready() {
        super.ready();

        const swiper = new Swiper(".mySwiper-multiple", {
            slidesPerView: 1,
            centeredSlides: false,
            slidesPerGroupSkip: 1,
            grabCursor: true,
            keyboard: {
                enabled: true,
            },
            breakpoints: {
                769: {
                    slidesPerView: 3.5,
                    slidesPerGroup: 3,
                    spaceBetween: 30,
                },
            },
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }
}